// Types
import {
  CancelDropModalHandlerReturnType,
  CancelDropModalHandlerType,
} from './types/cancel-drop-modal.handlers.type';
// Utilities
import { getModalMaxWidth } from '../utils/cancel-drop-modal.component.utils';

const recalculateWidthHandler = ({ setMaxWidth }: CancelDropModalHandlerType): void => {
  setMaxWidth(getModalMaxWidth());
};

const CancelDropModalHandlers = (
  props: CancelDropModalHandlerType
): CancelDropModalHandlerReturnType => ({
  handleRecalculateWidth: () => recalculateWidthHandler(props),
});

export default CancelDropModalHandlers;
